import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import BottomInfoBar from './BottomInfoBar';
import BottomInfoBarV2 from './BottomInfoBar.feed_thumb_award';
export default withFeatureBranch({
    feed_thumb_award: BottomInfoBarV2
})(BottomInfoBar);
